/* eslint-env browser */

export const TrackedEvent = {
    START_REGISTRATION: 'start_registration',
    SCHEDULE_DEMO: 'schedule_demo',
    GENERATE_LEAD: 'generate_lead',
    BOOK_MEETING: 'book_meeting',
    LOGIN: 'login',
};

export const pushEvent = (event) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event });
};

export const trackClicks = () => {
    const onClick = (e) => {
        if (e.type === 'auxclick' && e.button !== 1) return;
        const tracked = e.target instanceof Element ? e.target.closest('[data-track]') : null;
        if (tracked) pushEvent(tracked.dataset.track);
    };
    document.addEventListener('click', onClick);
    document.addEventListener('auxclick', onClick);
    return () => {
        document.removeEventListener('click', onClick);
        document.removeEventListener('auxclick', onClick);
    };
};
